/*!
 * shuffle-letters
 * A JavaScript library to shuffle the text content of a DOM element with an animated effect.
 *
 * @version v1.0.2
 * @author George Raptis <georapbox@gmail.com>
 * @homepage https://github.com/georapbox/shuffle-letters#readme
 * @repository git+https://github.com/georapbox/shuffle-letters.git
 * @license MIT
 */
function t(t, e) {
  var r = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), r.push.apply(r, n);
  }

  return r;
}

function e(e) {
  for (var n = 1; n < arguments.length; n++) {
    var o = null != arguments[n] ? arguments[n] : {};
    n % 2 ? t(Object(o), !0).forEach(function (t) {
      r(e, t, o[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : t(Object(o)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
    });
  }

  return e;
}

function r(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}

function n(t) {
  return function (t) {
    if (Array.isArray(t)) return o(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || function (t, e) {
    if (!t) return;
    if ("string" == typeof t) return o(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    "Object" === r && t.constructor && (r = t.constructor.name);
    if ("Map" === r || "Set" === r) return Array.from(t);
    if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return o(t, e);
  }(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function o(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var r = 0, n = new Array(e); r < e; r++) {
    n[r] = t[r];
  }

  return n;
}

function i(t) {
  var e = "";
  "lowerCase" === t ? e = "abcdefghijklmnopqrstuvwxyz0123456789" : "upperCase" === t ? e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789" : "symbol" === t && (e = ",.?/\\(^)![]{}*&^%$#'\"");
  var r = e.split("");
  return r[Math.floor(Math.random() * r.length)];
}

function a(t) {
  return !!t && 1 === t.nodeType && t instanceof Element == !0;
}

function u(t) {
  var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      o = {
    text: "",
    iterations: 8,
    fps: 30,
    onComplete: function onComplete() {}
  },
      u = e(e({}, o), r);
  if (!a(t)) throw new TypeError("Expected element to be a valid HTML element.");

  for (var l = u.text && "string" == typeof u.text ? u.text.split("") : t.textContent.split(""), c = [], f = [], s = 0; s < l.length; s += 1) {
    var p = l[s];
    /\s/.test(p) ? c[s] = "space" : (/[a-z]/.test(p) ? c[s] = "lowerCase" : /[A-Z]/.test(p) ? c[s] = "upperCase" : c[s] = "symbol", f.push(s));
  }

  t.textContent = "";
  var y = null;
  return function e(r) {
    var o = n(l),
        a = f.length;
    if (r > a) "function" == typeof u.onComplete && u.onComplete(t);else {
      for (var s = Math.max(r, 0); s < a; s += 1) {
        s < r + u.iterations ? o[f[s]] = i(c[f[s]]) : o[f[s]] = "";
      }

      t.textContent = o.join(""), y = setTimeout(function () {
        e(r + 1);
      }, 1e3 / u.fps);
    }
  }(-u.iterations), function () {
    clearTimeout(y), y = null;
  };
}

export default u;